import { render, staticRenderFns } from "./KanbanHeader.vue?vue&type=template&id=9fe821bc&scoped=true&"
import script from "./KanbanHeader.vue?vue&type=script&lang=js&"
export * from "./KanbanHeader.vue?vue&type=script&lang=js&"
import style0 from "./KanbanHeader.vue?vue&type=style&index=0&id=9fe821bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe821bc",
  null
  
)

export default component.exports